<template>
  <v-row id="qb-nav" align="center">
    <v-col cols="8" sm="4" md="6" class="text-start mt-1">
      <a href="../">
        <img src="assets/img/qbits-logo-solo.png" class="d-md-none" />
        <img src="assets/img/qbits-logo.png" class="d-none d-md-inline ml-n2" />
      </a>
    </v-col>
    <v-col cols="16" sm="20" md="18">
      <v-row align="center" class="pt-sm-6">
        <v-col cols="24" md="16" class="text-end d-none d-sm-block">
          <v-row justify="end" class="mr-n1 mr-md-0">
            <v-col cols="24" sm="7" lg="8">
              <v-btn text small :to="{ name: 'minting' }">
                <span class="pt-2p">{{ $t('nav.minting') }}</span>
              </v-btn>
            </v-col>
            <v-col cols="24" sm="8" lg="8">
              <v-btn text small :to="{ name: 'collection' }">
                <span class="pt-2p">{{ $t('nav.collection') }}</span>
              </v-btn>
            </v-col>
            <v-col cols="24" sm="9" lg="8">
              <v-btn text small :to="{ name: 'portfolio' }">
                <span class="pt-2p">{{ $t('nav.portfolio') }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="8" class="icon-col-md d-none d-md-block text-end">
          <v-btn icon plain class="mr-3">
            <v-icon size="30">$vuetify.icons.discord</v-icon>
          </v-btn>
          <v-btn icon plain class="mr-2">
            <v-icon size="34">mdi-twitter</v-icon>
          </v-btn>
          <v-btn icon plain class="mr-n1">
            <v-icon size="30">mdi-instagram</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <div class="text-end">
        <v-menu-ext left nudge-bottom="10">
          <template #activator="{ on: onNavMenu }">
            <span>
              <v-btn text small class="primary--text text-none text-body-3 hover-menu-dn mr-n1 d-none d-sm-inline-flex" min-width="130px" v-on="onNavMenu" v-if="web3Account">
                <v-icon color="primary" small class="mr-1 pb-1p">mdi-wallet-outline</v-icon>
                {{ web3Account | shortenHash }}
              </v-btn>
              <v-btn text small class="primary--text text-body-3 mr-n1 d-none d-sm-inline-flex" min-width="130px" @click="$store.dispatch('web3Connect')" v-else>
                <v-icon color="primary" small class="mr-1 pb-1p">mdi-wallet-outline</v-icon>
                {{ $t('shared.connect') }}
              </v-btn>
              <v-btn icon v-on="onNavMenu" class="d-sm-none">
                <v-icon large>mdi-menu</v-icon>
              </v-btn>
            </span>
          </template>
          <v-list dense>
            <v-list-item class="primary--text justify-end d-sm-none" v-if="web3Account">
              <v-icon color="primary" small class="mr-1">mdi-wallet-outline</v-icon>
              {{ web3Account | shortenHash }}
            </v-list-item>
            <v-list-item :to="{ name: 'minting' }" class="d-sm-none">
              <v-list-item-content class="justify-end">{{ $t('nav.minting') }}</v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'collection' }" class="d-sm-none">
              <v-list-item-content class="justify-end">{{ $t('nav.collection') }}</v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'portfolio' }" class="mb-1 d-sm-none">
              <v-list-item-content class="justify-end">{{ $t('nav.portfolio') }}</v-list-item-content>
            </v-list-item>
            <v-divider class="white-disabled--border mx-2" />
            <v-list-item @click="$store.dispatch('web3SwitchAccount')" class="mt-1 mt-sm-0" v-if="web3Account">
              <v-list-item-content class="justify-end">{{ $t('nav.changeWallet') }}</v-list-item-content>
            </v-list-item>
            <v-list-item @click="$store.dispatch('web3ResetApp')" v-if="web3Account">
              <v-list-item-content class="justify-end">{{ $t('nav.disconnectWallet') }}</v-list-item-content>
            </v-list-item>
            <v-list-item @click="$store.dispatch('web3Connect')" class="mt-2 mt-sm-0 d-sm-none" v-else>
              <v-list-item-content class="justify-end">{{ $t('shared.connectWallet') }}</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu-ext>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  computed: {
    web3Account () {
      return this.$store.getters.web3Account
    }
  }
}
</script>

<style lang="scss">
  @import '@/styles/main.scss';

  #qb-nav {
    z-index: 2;
    position: relative;
    .v-btn.v-btn--icon .v-btn__content {
      opacity: 1;
      i { color: white; }
      svg { fill: white }
      &:hover {
        i { color: $accent; }
        svg { fill: $accent }
      }
    }
  }
</style>
